import React from 'react';

const services = [
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M3 10.5 12 3l9 7.5"></path>
        <path d="M5 9.5V21h14V9.5"></path>
        <path d="M9 21v-6h6v6"></path>
      </svg>
    ),
    title: 'Real Estate Photography',
    description: 'Bright, true-to-life interior and exterior photography for agents, builders, and homeowners. Listing-ready images delivered in 24–48 hours so your property goes live on schedule.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    ),
    title: 'Portrait Photography',
    description: 'Relaxed, natural portraits and professional headshots. I take the time to understand what you want the images to say, then guide you through a comfortable, unhurried session.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <rect x="2" y="7" width="20" height="14" rx="2"></rect>
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"></path>
      </svg>
    ),
    title: 'Commercial Photography',
    description: 'Product, workspace, and on-location photography for businesses that need clean, polished images for their website, listings, and marketing — delivered fast and built to your brief.'
  },
  {
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="M12 2 2 7l10 5 10-5-10-5z"></path>
        <path d="M2 17l10 5 10-5"></path>
        <path d="M2 12l10 5 10-5"></path>
      </svg>
    ),
    title: 'Branding Photography',
    description: 'A cohesive library of images that tells the story of you and your business — team portraits, behind-the-scenes, and lifestyle shots planned together around your brand.'
  },
];

const Services = () => {
  return (
    <section id="services" className="section" aria-labelledby="services-title">
      <div className="container">
        <header className="section__header">
          <span className="section__tagline">What I Offer</span>
          <h2 id="services-title" className="section__title">Photography Services</h2>
          <p className="section__description">
            Real estate, portrait, commercial, and branding photography — every shoot handled
            personally by me, from first message to final delivery. You get a dedicated
            photographer who listens, shows up prepared, and turns your images around fast.
          </p>
        </header>
        <div className="services__grid" role="list">
          {services.map((service, index) => (
            <article key={index} className="service-card" role="listitem">
              <div className="service-card__icon" aria-hidden="true">
                {service.icon}
              </div>
              <h3 className="service-card__title">{service.title}</h3>
              <p className="service-card__description">{service.description}</p>
            </article>
          ))}
        </div>
        <div className="portfolio__cta" style={{ marginTop: 'var(--spacing-lg)' }}>
          <a href="#contact" className="btn btn--primary">
            Discuss Your Project
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
